import React, { useState, useEffect } from "react";
import SmallScreenSidebar from "../SmallScreenSidebar";
import DisplayDeshboard from "./DisplayDeshboard";
import { MyContextSupply } from "../../../Context";
import "../admin.css";
import { AiOutlineBars } from "react-icons/ai";
import axios from "axios";
import AdminSkeleton from "../AdminSkeleton/AdminSkeleton";

const AdminDeshboard = () => {
  const { setIsAdminSidebarOpen, token } = MyContextSupply();
  const [products, setProducts] = useState([]);
  const [users, setUsers] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isUserDelete, setIsUserDeleted] = useState(0);

  // console.log(orders);
  // console.log(users);
  // console.log(products);

  const getAllDashboardInfo = async () => {
    setIsLoading(true);
    await axios
      .get("https://stechbackend-9r4c.onrender.com/getalldashboardinfo", {
        headers: { Authorization: token },
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 200) {
          setProducts(res.data.products);
          setOrders(res.data.orders);
          setUsers(res.data.users);
          setAdmins(res.data.admins);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAllDashboardInfo();
  }, [isUserDelete]);

  return (
    <section className="main-prod">
      <SmallScreenSidebar />
      <button
        onClick={() => setIsAdminSidebarOpen(true)}
        className="smallsidebar-open-btn"
      >
        <AiOutlineBars />
      </button>
      <div></div>
      <div className="deshboard-content-part">
        <h1 style={{ textAlign: "center" }}>Website Details</h1>
        {isLoading ? (
          <AdminSkeleton />
        ) : (
          <DisplayDeshboard
            orders={orders}
            users={users}
            admins={admins}
            products={products}
            setIsUserDeleted={setIsUserDeleted}
          />
        )}
      </div>
    </section>
  );
};

export default AdminDeshboard;
